@let connector =
  connectorsEc.plugins.currentEntityPlugin.feature.selectors
    .getEditedEntity()
    .asSignal();
@if (connector) {
  @let isCreating =
    connectorsEc.plugins.currentEntityPlugin.feature.selectors
      .isCreating()
      .asSignal();
  @let definitions =
    definitionsEc.plugins.currentListPlugin.feature.selectors.entities.asSignal();
  @let definitionsLoading =
    definitionsEc.plugins.currentListPlugin.feature.selectors.isLoading.asSignal();
  @let isSubmitting =
    connectorsEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();
  @let submissionError =
    connectorsEc.plugins.editingPlugin.feature.selectors.submissionError.asSignal();

  <atn-ds-centered-overlay type="narrow">
    <atn-ds-widget
      class="atn-integration-connector-modal"
      [title]="isCreating ? 'Create connector' : 'Edit connector'"
    >
      <i
        actions
        class="atn-icon atn-close atn-red"
        (click)="cancel()"
      ></i>
      <div class="atn-integration-connector-modal__content">
        <atn-ds-text
          label="Integration name"
          placeholder="Attain GitHub pull requests"
          [value]="connector.name"
          (change)="updateName($event ?? '')"
        />
        <atn-ds-select-single
          label="Connector definition"
          placeholder="Select a definition"
          [required]="true"
          [loading]="definitionsLoading"
          [items]="definitionItems(definitions)"
          [value]="connector.definitionId"
          (valueChange)="$event && updateDefinitionId($event)"
        />
        <atn-ds-text
          label="Base URL"
          placeholder="https://customer.atlassian.net"
          [value]="connector.baseUrl"
          (change)="updateBaseUrl($event ?? '')"
        />
        @if (isCreating) {
          <label class="atn-ds-input-field">
            <span class="atn-ds-input-field__label">API key</span>
            <input
              class="atn-ds-input-field__control"
              type="password"
              autocomplete="new-password"
              [value]="'apiKey' in connector ? connector.apiKey : ''"
              (change)="updateApiKey($any($event.target).value)"
            />
          </label>
        }
        <atn-admin-error-message [message]="submissionError" />
      </div>
      <div
        class="atn-integration-connector-modal__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancel()"
        >
          Cancel
        </atn-ds-button>
        <atn-ds-button
          [disabled]="isSubmitting || !connector.name"
          (click)="save()"
        >
          Save
        </atn-ds-button>
      </div>
    </atn-ds-widget>
  </atn-ds-centered-overlay>
}
